const STORAGE_PREFIX = "adatis_br_holidays_reminder_dismissed";

export const brHolidaysReminderStorageKey = (tenantId: number | string, year: number): string =>
  `${STORAGE_PREFIX}:${tenantId}:${year}`;

export const isBrHolidaysReminderDismissed = (
  tenantId: number | string | null | undefined,
  year: number
): boolean => {
  if (tenantId === null || tenantId === undefined || tenantId === "") {
    return false;
  }

  try {
    return localStorage.getItem(brHolidaysReminderStorageKey(tenantId, year)) === "1";
  } catch {
    return false;
  }
};

export const dismissBrHolidaysReminder = (
  tenantId: number | string | null | undefined,
  year: number
): void => {
  if (tenantId === null || tenantId === undefined || tenantId === "") {
    return;
  }

  try {
    localStorage.setItem(brHolidaysReminderStorageKey(tenantId, year), "1");
  } catch {
    // ignore quota / private mode
  }
};

/** Show soft reminder from November of previous year through the target year. */
export const shouldOfferBrHolidaysReminder = (now: Date = new Date()): number | null => {
  const year = now.getFullYear();
  const month = now.getMonth(); // 0-based

  if (month >= 10) {
    return year + 1;
  }

  if (month <= 1) {
    return year;
  }

  return null;
};
